<template>
  <div class="main">
    <router-link to="/act3/main">
      <div class="main" style="background-image:url(static/img/act/3/banner.jpg?v=2)" >
        <img  class="act-3-banner-btn-show" src="static/img/act/3/btn-show.png" />
      </div>
    </router-link>    
  </div>
</template>
 

<script>

export default {
  name: "Act4Banner",
  components: {
  },
  data() {
    return {
    };
  },
  mounted() {},
  created() {
      //站点设置
      this.setDocumentV2(
        "三江侗族大歌节",
        "",
        "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/share.jpg?v=2"
      );
      _czc.push(['_trackEvent', '三江侗族大歌节', '点击', '主页面','0','3']);
      //移除loading
      this.removeLoader()
  },
  methods: {
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.main {
  position: absolute;
  width: 100%;
  height: 100%;
  background-position: 50% !important;
  background-size: cover !important;
  overflow: hidden
} 

.act-3-banner-btn-show{
  position: absolute;
  top: 42%;
  left: 4%;
  width: 12%;
  height: auto;
}
 
</style>


// WEBPACK FOOTER //
// src/components/act/3/Banner.vue